
import { defineComponent, ref, onMounted } from "vue";
import { usePlugin } from "@/plugins";
import {
  Question,
  GetQuestionRequest,
  GetQuestionResponse,
  CopyQuestionRequest,
  CopyQuestionResponse,
  DeleteQuestionRequest,
} from "@/types";
import BackButton from "@/components/BackButton.vue";

export default defineComponent({
  name: "QuestionList",
  components: { BackButton },
  setup() {
    const {
      router,
      setLoading,
      error,
      success,
      axios,
      formatAppDate,
      confirmation,
    } = usePlugin();
    const onNewQuestion = () => {
      router.push({ name: "newQuestion" });
    };

    const questions = ref<Question[]>([]);
    const loadDocuments = async () => {
      setLoading(true);
      try {
        var result = await axios.post<GetQuestionResponse>(
          "api/v1/services/question/get",
          {} as GetQuestionRequest
        );
        questions.value = result.data.questions ?? [];
        success("ดึงข้อมูลสำเร็จแล้ว");
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onEdit = (id: number) => {
      router.push({ name: "editQuestion", params: { id: id } });
    };

    const showPopupCopy = ref(false);
    const copyName = ref("");
    const copyId = ref(0);
    const onCopy = (id: number) => {
      showPopupCopy.value = true;
      copyId.value = id;
    };

    const onConfirmCopy = async () => {
      setLoading(true);
      try {
        var result = await axios.post<CopyQuestionResponse>(
          "api/v1/services/question/copy",
          {
            questionId: copyId.value,
            description: copyName.value,
          } as CopyQuestionRequest
        );
        success("Copy ข้อมูลเรียบร้อยแล้ว");
        router.push({
          name: "editQuestion",
          params: { id: result.data.questionId },
        });
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onDelete = async (id: number) => {
      confirmation.require({
        message: "กรุณายืนยันเพื่อทำการลบแบบประเมินนี้",
        header: `ลบแบบประเมิน ${id}`,
        acceptLabel: "ยืนยันลบ",
        accept: async () => {
          setLoading(false);
          try {
            await axios.post("api/v1/services/question/delete", {
              questionId: id,
            } as DeleteQuestionRequest);

            success("ลบข้อมูลเรียบร้อยแล้ว");
            await loadDocuments();
          } catch (e) {
            error(e);
          } finally {
            setLoading(false);
          }
        },
        rejectLabel: "ยกเลิก",
      });
    };

    onMounted(async () => {
      await loadDocuments();
    });

    return {
      onNewQuestion,
      questions,
      onEdit,
      formatAppDate,
      showPopupCopy,
      onCopy,
      copyName,
      onConfirmCopy,
      onDelete,
    };
  },
});
